import React from 'react'

import './Preview.scss'

const Preview = ({ headerText = '', descriptionText = '', imageSrc = '', imageDisclaimerText = '' }) => {
    return (
        <div className="lead-form-final-review">
            {imageSrc.length ? <div className="image" style={{ backgroundImage: `url(${imageSrc})` }}></div> : null}
            {headerText.length ? <div className="header">{headerText}</div> : null}
            {descriptionText.length ? <div className="description">{descriptionText}</div> : null}
            {imageSrc.length && imageDisclaimerText.length ? (
                <div className="image-disclaimer">{imageDisclaimerText}</div>
            ) : null}
        </div>
    )
}

export default Preview
